import React, { useEffect, useRef, useState } from "react";
import { Editor } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import pagesService from "../../../services/pagesService.js";

const ModalPage = ({ editingModal, titleSingular, isModalOpen, onClose }) => {
    const editorRef = useRef();
    const [titulo, setTitulo] = useState("");

    useEffect(() => {
        if (editingModal) {
            setTitulo(editingModal.title || "");
            if (editingModal.content && editorRef.current) {
                editorRef.current.getInstance().setHTML(editingModal.content);
            }
        } else {
            setTitulo("");
            if (editorRef.current) {
                editorRef.current.getInstance().setHTML("");
            }
        }
    }, [editingModal]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const content = editorRef.current?.getInstance().getHTML();

        const payload = {
            id: editingModal?.id || null,
            title: titulo,
            content: content
        };

        try {
            await pagesService.saveOrUpdatePage(payload);
            onClose();
        } catch (error) {
            console.error("Error al guardar la página:", error);
        }
    };

    if (!isModalOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content modal-content-lg">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>{editingModal ? `Editar ${titleSingular}` : `Crear ${titleSingular}`}</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="titulo">Título</label>
                        <input
                            type="text"
                            id="titulo"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group mt-3">
                        <label>Contenido</label>
                        <Editor
                            previewStyle="vertical"
                            height="400px"
                            initialEditType="wysiwyg"
                            hideModeSwitch={true}
                            useCommandShortcut={true}
                            ref={editorRef}
                        />
                    </div>

                    <div className="form-actions mt-3">
                        <button type="submit" className="btn btn-primary me-2">Guardar</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ModalPage;